module.exports = __webpack_public_path__ + "li.svg?ca65e1ea4a1fbe7863b70ab6a24d8ac8";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/li.svg
// module id = 1304
// module chunks = 27